import gsap from "gsap";
import { Color, Vector3 } from "three";
import { angelopolisApi } from "../../api/angelopolisAPi";
import { getUrlParamZone } from "../../utils/urlParams";
import { ModalLotes } from "../modals/LotesModal";
import { ModalAngelopolis } from "../modals/ModalAngelopolis";
import { ZoneModalInfo } from "../modals/ZoneInfoModal";
import { isDevice } from "./../../utils/isDevice";

export class Menu {
  constructor(camera, iconsgltf, directional, gltf, control, gltfMaps) {
    if (Menu.instance) {
      return Menu.instance;
    }
    Menu.instance = this;
    this.iconsgltf = iconsgltf;
    this.gltf = gltf;
    this.menuClickEnable = true;
    this.gltfMaps = gltfMaps;
    this.control = control;
    this.zoneModalInfo = new ZoneModalInfo();
    this.modalAngelopolis = new ModalAngelopolis();
    this.modalLotesinClouster = new ModalLotes();
    this.angelApi = new angelopolisApi();
    this.camera = camera;
    this.directional = directional;
    this._topCamera = true;
    this._leveCamera = 0;
    this.initUiElements();
    this.initUiListteners();
    this.uiHoverListeners();
    this.validateisOpenCluster();
    if (isDevice()) {
      this.changeNameMenus();
    }
    if (getUrlParamZone()) {
      this.allMenuZones.classList.replace("hidden", "flex");
    }
    this.clickClouster(getUrlParamZone());
  }

  get leveCamera() {
    return this._leveCamera;
  }
  set leveCamera(leve) {
    this._leveCamera = leve;
  }

  get topCamera() {
    return this._topCamera;
  }
  set topCamera(topCamera) {
    this._topCamera = topCamera;
    if (this._topCamera) {
      this.iconsgltf.showModelComplete();
    } else {
      this.iconsgltf.hidenModelComplete();
    }
  }
  validateisOpenCluster() {
    const uiElements = [
      {
        father: this.menuZoneOne,
        childrens: [
          {
            //fontana
            uiElement: this.oneClousterOne,
            slug: "A-110 B",
          },
          {
            //sacramento
            uiElement: this.oneClousterTwo,
            slug: "A-110A",
          },
          {
            //arcadia
            uiElement: this.oneClousterThree,
            slug: "A-108 B",
          },
          {
            //rinconada
            uiElement: this.oneClousterFour,
            slug: "A-106",
          },
          {
            //galena
            uiElement: this.oneClousterFive,
            slug: "A108A/A109",
          },
          {
            //Milos
            uiElement: this.oneClousterSix,
            slug: "A-101D",
          },
          {
            //zante
            uiElement: this.threeClousterTwo,
            slug: "A-177 B",
          },
        ],
      },
      {
        father: this.menuZoneTwo,
        childrens: [
          {
            //capri
            uiElement: this.twoClousterOne,
            slug: "*************",
          },
          {
            //creta
            uiElement: this.twoClousterTwo,
            slug: "A-91",
          },
          {
            //rodas
            uiElement: this.twoClousterThree,
            slug: "*************",
          },
          {
            //bali
            uiElement: this.twoClousterFour,
            slug: "D-67AB/D70",
          },
        ],
      },
      {
        father:this.menuZoneSix,
         childrens: [
          {
            //mmontenegro
            uiElement: this.sixClousterThree,
            slug: "C4"
          },
         ]
      },
      {
        father: this.menuZoneSeven,
        childrens: [
          {
            //lucerna
            uiElement: this.sevenClousterOne,
            slug: "C-30",
          },
          {
            //cantera
            uiElement: this.sevenClousterTwo,
            slug: "D-28",
          },
          {
            //TerraVerde
            uiElement: this.sevenClousterThree,
            slug: "A-35",
          },
        ],
      },

      {
        father: this.menuZoneThree,
        childrens: [
          {
            //vilansa
            uiElement: this.threeClousterOne,
            slug: "A-176",
          },
        ],
      },
      {
        father: this.menuZoneFive,
        childrens: [
          {
            //parque viena
            uiElement: this.fiveClousterOne,
            slug: "*************",
          },
          {
            //parque berna
            uiElement: this.fiveClousterTwo,
            slug: "*************",
          },
          {
            //palermo
            uiElement: this.fiveClousterFour,
            slug: "A-9F1",
          },
          {
            //sofia
            uiElement: this.fiveClousterThree,
            slug: "A-9D",
          },
        ],
      },
      {
        father: this.menuZoneFive,
        childrens: [
          {
            //parque viena
            uiElement: this.fiveClousterOne,
            slug: "*************",
          },
          {
            //parque berna
            uiElement: this.fiveClousterTwo,
            slug: "*************",
          },
          {
            //palermo
            uiElement: this.fiveClousterFour,
            slug: "A-9F1",
          },
          {
            //sofia
            uiElement: this.fiveClousterThree,
            slug: "A-9D",
          },
        ],
      },

      {
        father: this.menuZoneEight,
        childrens: [
          {
            //trento
            uiElement: this.eightClousterOne,
            slug: "A-119A",
          },
          {
            // verona
            uiElement: this.eightClousterTwo,
            slug: "A-114D",
          },
          {
            // sorrento
            uiElement: this.eightClousterThree,
            slug: "A-118",
          },
          {
            // ferrara
            uiElement: this.eightClousterFour,
            slug: "A-119B",
          },
          {
            // siena
            uiElement: this.eightClousterFive,
            slug: "A-115AB",
          },
        ],
      },
    ];
    uiElements.forEach((element) => {
      const hiddenChildren = element.childrens.filter(
        (children) =>
          children.slug === "*************" ||
          this.angelApi.clusters.some(
            (clus) => clus.slug === children.slug && !clus.isOpend
          )
      );
      if (hiddenChildren.length === 0) return;
      if (hiddenChildren.length === element.childrens.length) {
        element.father.classList.add("hidden");
      }
      hiddenChildren.forEach((children) => {
        children.uiElement.classList.add("hidden");
      });
    });
  }

  initUiElements() {
    this.accesosSwitch = document.getElementById("accesosSwitch");

    this.menuGeneralView = document.querySelector("#menuGeneralView");

    // circulos medianos
    this.menuZoneOne = document.querySelector("#menuZoneOne");
    this.menuZoneTwo = document.querySelector("#menuZoneTwo");
    this.menuZoneThree = document.querySelector("#menuZoneThree");
    this.menuZoneFour = document.querySelector("#menuZoneFour");
    this.menuZoneFive = document.querySelector("#menuZoneFive");
    this.menuZoneSix = document.querySelector("#menuZoneSix");
    this.menuZoneSeven = document.querySelector("#menuZoneSeven");
    this.menuZoneEight = document.querySelector("#menuZoneEight");

    // labes zones
    this.labelZoneOne = document.querySelector("#labelZoneOne");
    this.labelZoneTwo = document.querySelector("#labelZoneTwo");
    this.labelZoneThree = document.querySelector("#labelZoneThree");
    this.labelZoneFour = document.querySelector("#labelZoneFour");
    this.labelZoneFive = document.querySelector("#labelZoneFive");
    this.labelZoneSix = document.querySelector("#labelZoneSix");
    this.labelZoneSeven = document.querySelector("#labelZoneSeven");
    this.labelZoneEight = document.querySelector("#labelZoneEight");
    this.labelsZones = [
      this.labelZoneOne,
      this.labelZoneTwo,
      this.labelZoneThree,
      this.labelZoneFour,
      this.labelZoneFive,
      this.labelZoneSix,
      this.labelZoneSeven,
      this.labelZoneEight,
    ];

    this.allMenuZones = document.querySelector("#allMenuZones");
    // labes clousters
    this.labelClousterOne = document.querySelector("#labelClousterOne");
    this.labelClousterTwo = document.querySelector("#labelClousterTwo");
    this.labelClousterThree = document.querySelector("#labelClousterThree");
    this.labelClousterFour = document.querySelector("#labelClousterFour");
    this.labelClousterFive = document.querySelector("#labelClousterFive");
    //
    this.twoLabelClousterOne = document.querySelector("#twoLabelClousterOne");
    this.twoLabelClousterTwo = document.querySelector("#twoLabelClousterTwo");
    this.twoLabelClousterThree = document.querySelector(
      "#twoLabelClousterThree"
    );
    this.twoLabelClousterFour = document.querySelector("#twoLabelClousterFour");
    this.twoLabelClousterFive = document.querySelector("#twoLabelClousterFive");
    this.twoLabelClousterSix = document.querySelector("#twoLabelClousterSix");

    this.threeLabelClousterOne = document.querySelector(
      "#threeLabelClousterOne"
    );
    this.threeLabelClousterTwo = document.querySelector(
      "#threeLabelClousterTwo"
    );

    this.fiveLabelClousterOne = document.querySelector("#fiveLabelClousterOne");
    this.fiveLabelClousterTwo = document.querySelector("#fiveLabelClousterTwo");
    this.fiveLabelClousterThree = document.querySelector(
      "#fiveLabelClousterThree"
    );
    this.fiveLabelClousterFour = document.querySelector(
      "#fiveLabelClousterFour"
    );

    this.sixLabelClousterOne = document.querySelector("#sixLabelClousterOne");
    this.sixLabelClousterTwo = document.querySelector("#sixLabelClousterTwo");
    this.sixLabelClousterThree = document.querySelector("#sixLabelClousterThree");

    this.sevenLabelClousterOne = document.querySelector(
      "#sevenLabelClousterOne"
    );
    this.SevenLabelClousterTwo = document.querySelector(
      "#SevenLabelClousterTwo"
    );
    this.sevenLabelClousterThree = document.querySelector(
      "#sevenLabelClousterThree"
    );
    this.oneLabelClousterSix = document.querySelector("#oneLabelClousterSix");
    //
    this.eightLabelClousterOne = document.querySelector(
      "#eightLabelClousterOne"
    );
    this.eightLabelClousterTwo = document.querySelector(
      "#eightLabelClousterTwo"
    );
    this.eightLabelClousterThree = document.querySelector(
      "#eightLabelClousterThree"
    );
    this.eightLabelClousterFour = document.querySelector(
      "#eightLabelClousterFour"
    );
    this.eightLabelClousterFive = document.querySelector(
      "#eightLabelClousterFive"
    );

    this.labelClousters = [
      this.sevenLabelClousterOne,
      this.SevenLabelClousterTwo,
      this.sevenLabelClousterThree,
      this.oneLabelClousterSix,
      this.twoLabelClousterOne,
      this.twoLabelClousterTwo,
      this.twoLabelClousterThree,
      this.twoLabelClousterFour,
      this.twoLabelClousterFive,
      this.twoLabelClousterSix,
      this.labelClousterFour,
      this.labelClousterFive,
      this.labelClousterOne,
      this.labelClousterTwo,
      this.labelClousterThree,
      this.threeLabelClousterOne,
      this.threeLabelClousterTwo,
      this.fiveLabelClousterOne,
      this.fiveLabelClousterTwo,
      this.fiveLabelClousterThree,
      this.fiveLabelClousterFour,
      this.sixLabelClousterOne,
      this.sixLabelClousterTwo,
      this.sixLabelClousterThree,
      this.eightLabelClousterOne,
      this.eightLabelClousterTwo,
      this.eightLabelClousterThree,
      this.eightLabelClousterFour,
      this.eightLabelClousterFive,
    ];
    // end labes

    //  menus desplegables
    this.menuZoneOneClousters = document.querySelector("#menuZoneOneClousters");
    this.menuZoneTwoClousters = document.querySelector("#menuZoneTwoClousters");
    this.menuZoneThreeClousters = document.querySelector(
      "#menuZoneThreeClousters"
    );
    this.menuZoneFourClousters = document.querySelector(
      "#menuZoneFourClousters"
    );
    this.menuZoneFiveClousters = document.querySelector(
      "#menuZoneFiveClousters"
    );
    this.menuZoneSixClousters = document.querySelector("#menuZoneSixClousters");
    this.menuZoneSevenClousters = document.querySelector(
      "#menuZoneSevenClousters"
    );
    this.menuZoneEightClousters = document.querySelector(
      "#menuZoneEightClousters"
    );

    // circlulos chicos
    this.oneClousterOne = document.querySelector("#oneClousterOne");
    this.oneClousterTwo = document.querySelector("#oneClousterTwo");
    this.oneClousterThree = document.querySelector("#oneClousterThree");
    this.oneClousterFour = document.querySelector("#oneClousterFour");
    this.oneClousterFive = document.querySelector("#oneClousterFive");
    this.oneClousterSix = document.querySelector("#oneClousterSix");
    this.twoClousterOne = document.querySelector("#twoClousterOne");
    this.twoClousterTwo = document.querySelector("#twoClousterTwo");
    this.twoClousterThree = document.querySelector("#twoClousterThree");
    this.twoClousterFour = document.querySelector("#twoClousterFour");
    this.twoClousterFive = document.querySelector("#twoClousterFive");
    this.twoClousterSix = document.querySelector("#twoClousterSix");

    this.threeClousterOne = document.querySelector("#threeClousterOne");
    this.threeClousterTwo = document.querySelector("#threeClousterTwo");

    this.fiveClousterOne = document.querySelector("#fiveClousterOne");
    this.fiveClousterTwo = document.querySelector("#fiveClousterTwo");
    this.fiveClousterThree = document.querySelector("#fiveClousterThree");
    this.fiveClousterFour = document.querySelector("#fiveClousterFour");

    this.sixClousterOne = document.querySelector("#sixClousterOne");
    this.sixClousterTwo = document.querySelector("#sixClousterTwo");
    this.sixClousterThree = document.querySelector("#sixClousterThree");

    this.sevenClousterOne = document.querySelector("#sevenClousterOne");
    this.sevenClousterTwo = document.querySelector("#sevenClousterTwo");
    this.sevenClousterThree = document.querySelector("#sevenClousterThree");

    this.eightClousterOne = document.querySelector("#eightClousterOne");
    this.eightClousterTwo = document.querySelector("#eightClousterTwo");
    this.eightClousterThree = document.querySelector("#eightClousterThree");
    this.eightClousterFour = document.querySelector("#eightClousterFour");
    this.eightClousterFive = document.querySelector("#eightClousterFive");

    this.cloustersCircles = [
      this.oneClousterOne,
      this.oneClousterTwo,
      this.oneClousterThree,
      this.oneClousterFour,
      this.oneClousterFive,
      this.oneClousterSix,
      this.twoClousterOne,
      this.twoClousterTwo,
      this.twoClousterThree,
      this.twoClousterFour,
      this.twoClousterFive,
      this.twoClousterSix,
      this.threeClousterOne,
      this.threeClousterTwo,
      this.fiveClousterOne,
      this.fiveClousterTwo,
      this.fiveClousterThree,
      this.fiveClousterFour,
      this.sixClousterOne,
      this.sixClousterTwo,
      this.sixClousterThree,
      this.sevenClousterOne,
      this.sevenClousterTwo,
      this.sevenClousterThree,
      this.eightClousterOne,
      this.eightClousterTwo,
      this.eightClousterThree,
      this.eightClousterFour,
      this.eightClousterFive
    ];
    this.mediumCircles = [
      this.menuZoneOne,
      this.menuZoneTwo,
      this.menuZoneThree,
      this.menuZoneFour,
      this.menuZoneFive,
      this.menuZoneSix,
      this.menuZoneSeven,
      this.menuZoneEight,
    ];
  }
  changeNameMenus() {
    this.menuGeneralView.innerText = "LA";
    this.menuGeneralView.classList.replace("w-36", "w-10");
    this.menuGeneralView.classList.replace("h-12", "h-10");
    this.menuGeneralView.classList.remove("pl-2");
    this.menuGeneralView.classList.add("flex");

    this.mediumCircles.map((htmlElement) => {
      htmlElement.classList.replace("w-32", "w-8");
      htmlElement.classList.remove("pl-2");
      htmlElement.classList.add("flex");
    });
    this.menuZoneOne.children[0].innerText = "CL I";
    this.menuZoneTwo.children[0].innerText = "CL II";
    this.menuZoneThree.children[0].innerText = "CS II";
    this.menuZoneFour.children[0].innerText = "L I,II";
    this.menuZoneFive.children[0].innerText = "ZA";
    this.menuZoneSix.children[0].innerText = "DE";
    this.menuZoneSeven.children[0].innerText = "CS I";
    this.menuZoneSeven.children[0].innerText = "NZ";
    this.menuZoneEight.children[0].innerText = "LS";

    this.cloustersCircles.map((htmlElement) => {
      htmlElement.classList.replace("w-24", "w-5");
      htmlElement.classList.remove("pl-2");
      htmlElement.classList.add("flex");
    });
    this.oneClousterOne.children[0].innerText = "FO";
    this.oneClousterTwo.children[0].innerText = "SA";
    this.oneClousterThree.children[0].innerText = "AR";
    this.oneClousterFour.children[0].innerText = "RI";
    this.oneClousterFive.children[0].innerText = "GL";
    this.oneClousterSix.children[0].innerText = "MIL";
    this.twoClousterOne.children[0].innerText = "CA";
    this.twoClousterTwo.children[0].innerText = "CR";
    this.twoClousterThree.children[0].innerText = "RO";
    this.twoClousterFour.children[0].innerText = "BA";
    this.twoClousterFive.children[0].innerText = "NI";
    this.twoClousterSix.children[0].innerText = "AT";
    this.threeClousterOne.children[0].innerText = "VI";
    this.threeClousterTwo.children[0].innerText = "ZA";
    this.fiveClousterOne.children[0].innerText = "PV";
    this.fiveClousterTwo.children[0].innerText = "PB";
    this.fiveClousterThree.children[0].innerText = "SO";
    this.fiveClousterFour.children[0].innerText = "PA";
    this.sixClousterOne.children[0].innerText = "AN";
    this.sixClousterTwo.children[0].innerText = "BA";
    this.sixClousterThree.children[0].innerText = "MO";
    this.sevenClousterOne.children[0].innerText = "LU";
    this.sevenClousterTwo.children[0].innerText = "CA";
    this.sevenClousterThree.children[0].innerText = "TV";
    this.eightClousterOne.children[0].innerText = "TR";
    this.eightClousterTwo.children[0].innerText = "VE";
    this.eightClousterThree.children[0].innerText = "SO";
    this.eightClousterFour.children[0].innerText = "FE";
    this.eightClousterFive.children[0].innerText = "SI";
  }

  uiHoverListeners() {
    document.querySelector("#menuZoneOne").addEventListener("mouseover", () => {
      this.topCamera && this.leveCamera === 0
        ? this.gltf.hoverZones("Terreno_nuevaZona_MT_G_terreno_0")
        : false;
    });
    document.querySelector("#menuZoneTwo").addEventListener("mouseover", () => {
      this.topCamera && this.leveCamera === 0
        ? this.gltf.hoverZones("Terreno_nuevaZona2_MT_G_terreno_0")
        : false;
    });
    document
      .querySelector("#menuZoneThree")
      .addEventListener("mouseover", () => {
        this.topCamera && this.leveCamera === 0
          ? this.gltf.hoverZones("Terreno_cascatta2_MT_G_terreno_0")
          : false;
      });
    document
      .querySelector("#menuZoneFour")
      .addEventListener("mouseover", () => {
        this.topCamera && this.leveCamera === 0
          ? this.gltf.hoverZones("Lomas2_MT_G_terreno_0")
          : false;
      });
    document
      .querySelector("#menuZoneFive")
      .addEventListener("mouseover", () => {
        this.topCamera && this.leveCamera === 0
          ? this.gltf.hoverZones("Terreno_parques_MT_G_terreno_0")
          : false;
      });
    document.querySelector("#menuZoneSix").addEventListener("mouseover", () => {
      this.topCamera && this.leveCamera === 0
        ? this.gltf.hoverZones("Distrito_escolar_MT_G_terreno_0001")
        : false;
    });
    document
      .querySelector("#menuZoneSeven")
      .addEventListener("mouseover", () => {
        this.topCamera && this.leveCamera === 0
          ? this.gltf.hoverZones("Terreno_cascatta")
          : false;
      });
    document
      .querySelector("#menuZoneEight")
      .addEventListener("mouseover", () => {
        this.topCamera && this.leveCamera === 0
          ? this.gltf.hoverZones("Terreno_nuevaZona_3")
          : false;
      });

    document
      .querySelector("#oneClousterOne")
      .addEventListener("mouseover", () =>
        this.topCamera && this.leveCamera === 1
          ? this.gltf.hoverClousters("Banqueta_fontana_MT_G_terreno_0")
          : false
      );
    document
      .querySelector("#oneClousterTwo")
      .addEventListener("mouseover", () =>
        this.topCamera && this.leveCamera === 1
          ? this.gltf.hoverClousters("Banqueta_sacramento_MT_G_terreno_0")
          : false
      );
    document
      .querySelector("#oneClousterThree")
      .addEventListener("mouseover", () =>
        this.topCamera && this.leveCamera === 1
          ? this.gltf.hoverClousters("Banqueta_arcadia_MT_G_terreno_0")
          : false
      );
    document
      .querySelector("#oneClousterFour")
      .addEventListener("mouseover", () =>
        this.topCamera && this.leveCamera === 1
          ? this.gltf.hoverClousters("Banqueta_rinconada_MT_G_terreno_0")
          : false
      );
    document
      .querySelector("#oneClousterFive")
      .addEventListener("mouseover", () =>
        this.topCamera && this.leveCamera === 1
          ? this.gltf.hoverClousters("Galena4")
          : false
      );
    document
      .querySelector("#oneClousterSix")
      .addEventListener("mouseover", () =>
        this.topCamera && this.leveCamera === 1
          ? this.gltf.hoverClousters("Banqueta_Milos")
          : false
      );
    document
      .querySelector("#twoClousterOne")
      .addEventListener("mouseover", () =>
        this.topCamera && this.leveCamera === 1
          ? this.gltf.hoverClousters("Banqueta_capri_MT_G_terreno_0")
          : false
      );
    document
      .querySelector("#twoClousterTwo")
      .addEventListener("mouseover", () =>
        this.topCamera && this.leveCamera === 1
          ? this.gltf.hoverClousters("Banqueta_Creta_MT_G_terreno_0")
          : false
      );
    document
      .querySelector("#twoClousterThree")
      .addEventListener("mouseover", () =>
        this.topCamera && this.leveCamera === 1
          ? this.gltf.hoverClousters("Banqueta_rodas_MT_G_terreno_0")
          : false
      );
    document
      .querySelector("#twoClousterFour")
      .addEventListener("mouseover", () =>
        this.topCamera && this.leveCamera === 1
          ? this.gltf.hoverClousters("Banqueta_bali_MT_G_terreno_0")
          : false
      );
    document
      .querySelector("#twoClousterFive")
      .addEventListener("mouseover", () =>
        this.topCamera && this.leveCamera === 1
          ? this.gltf.hoverClousters("Banqueta_niza")
          : false
      );
    document
      .querySelector("#twoClousterSix")
      .addEventListener("mouseover", () =>
        this.topCamera && this.leveCamera === 1
          ? this.gltf.hoverClousters("Banqueta_antalya")
          : false
      );
    //
    document
      .querySelector("#threeClousterOne")
      .addEventListener("mouseover", () =>
        this.topCamera && this.leveCamera === 1
          ? this.gltf.hoverClousters("Banqueta_vilansa_MT_G_terreno_0")
          : false
      );
    document
      .querySelector("#threeClousterTwo")
      .addEventListener("mouseover", () =>
        this.topCamera && this.leveCamera === 1
          ? this.gltf.hoverClousters("Banqueta_zante")
          : false
      );
    document
      .querySelector("#fiveClousterOne")
      .addEventListener("mouseover", () =>
        this.topCamera && this.leveCamera === 1
          ? this.gltf.hoverClousters("Banqueta_parqueViena_MT_G_terreno_0")
          : false
      );
    document
      .querySelector("#fiveClousterTwo")
      .addEventListener("mouseover", () =>
        this.topCamera && this.leveCamera === 1
          ? this.gltf.hoverClousters("Banqueta_parqueBerna_MT_G_terreno_0")
          : false
      );
    document
      .querySelector("#fiveClousterThree")
      .addEventListener("mouseover", () =>
        this.topCamera && this.leveCamera === 1
          ? this.gltf.hoverClousters("Banqueta_sofia_MT_G_terreno_0")
          : false
      );
    document
      .querySelector("#fiveClousterFour")
      .addEventListener("mouseover", () =>
        this.topCamera && this.leveCamera === 1
          ? this.gltf.hoverClousters("Banqueta_palermo_MT_G_terreno_0")
          : false
      );
    document
      .querySelector("#sixClousterOne")
      .addEventListener("mouseover", () =>
        this.topCamera && this.leveCamera === 1
          ? this.gltf.hoverClousters("Banqueta_anturio_MT_G_terreno_0")
          : false
      );
    document
      .querySelector("#sixClousterTwo")
      .addEventListener("mouseover", () =>
        this.topCamera && this.leveCamera === 1
          ? this.gltf.hoverClousters("Banqueta_balcanes")
          : false
      );
    document
      .querySelector("#sixClousterThree")
      .addEventListener("mouseover", () =>
        this.topCamera && this.leveCamera === 1
          ? this.gltf.hoverClousters("Banqueta_Montenegro")
          : false
      );
    document
      .querySelector("#sevenClousterOne")
      .addEventListener("mouseover", () =>
        this.topCamera && this.leveCamera === 1
          ? this.gltf.hoverClousters("Banqueta_lucerna")
          : false
      );
    document
      .querySelector("#sevenClousterTwo")
      .addEventListener("mouseover", () =>
        this.topCamera && this.leveCamera === 1
          ? this.gltf.hoverClousters("Banqueta_lacantera")
          : false
      );
    document
      .querySelector("#sevenClousterThree")
      .addEventListener("mouseover", () =>
        this.topCamera && this.leveCamera === 1
          ? this.gltf.hoverClousters("Banqueta_TerraVerde")
          : false
      );

    document
      .querySelector("#eightClousterOne")
      .addEventListener("mouseover", () =>
        this.topCamera && this.leveCamera === 1
          ? this.gltf.hoverClousters("Banqueta_trento")
          : false
      );
    document
      .querySelector("#eightClousterTwo")
      .addEventListener("mouseover", () =>
        this.topCamera && this.leveCamera === 1
          ? this.gltf.hoverClousters("Banqueta_verona")
          : false
      );
    document
      .querySelector("#eightClousterThree")
      .addEventListener("mouseover", () =>
        this.topCamera && this.leveCamera === 1
          ? this.gltf.hoverClousters("Banqueta_sorrento")
          : false
      );
    document
      .querySelector("#eightClousterFour")
      .addEventListener("mouseover", () =>
        this.topCamera && this.leveCamera === 1
          ? this.gltf.hoverClousters("Banqueta_Ferrara")
          : false
      );
    document
      .querySelector("#eightClousterFive")
      .addEventListener("mouseover", () =>
        this.topCamera && this.leveCamera === 1
          ? this.gltf.hoverClousters("Banqueta_Siena")
          : false
      );
  }

  initUiListteners() {
    this.menuGeneralView.addEventListener("click", () => {
      if (this.menuClickEnable) {
        this.menuClickEnable = false;
        this.moveToGeneralView();
      }
    });
    this.oneClousterOne.addEventListener("click", () =>
      this._moveToClousterOne()
    );
    this.oneClousterTwo.addEventListener("click", () => {
      if (this.menuClickEnable) {
        this.menuClickEnable = false;
        this._moveToClousterTwo();
      }
    });
    this.oneClousterThree.addEventListener("click", () => {
      if (this.menuClickEnable) {
        this.menuClickEnable = false;
        this._moveToClousterThree();
      }
    });
    this.oneClousterFour.addEventListener("click", () => {
      if (this.menuClickEnable) {
        this.menuClickEnable = false;
        this._moveToClousterFour();
      }
    });
    this.oneClousterFive.addEventListener("click", () => {
      if (this.menuClickEnable) {
        this.menuClickEnable = false;
        this._moveToClousterFive();
      }
    });
    this.oneClousterSix.addEventListener("click", () => {
      if (this.menuClickEnable) {
        this.menuClickEnable = false;
        this._moveToClousterSix();
      }
    });
    this.twoClousterOne.addEventListener("click", () => {
      if (this.menuClickEnable) {
        this.menuClickEnable = false;
        this._moveToClousterOneZoneTwo();
      }
    });
    this.twoClousterTwo.addEventListener("click", () => {
      if (this.menuClickEnable) {
        this.menuClickEnable = false;
        this._moveToClousterTwoZoneTwo();
      }
    });
    this.twoClousterThree.addEventListener("click", () => {
      if (this.menuClickEnable) {
        this.menuClickEnable = false;
        this._moveToClousterThreeZoneTwo();
      }
    });
    this.twoClousterFour.addEventListener("click", () => {
      if (this.menuClickEnable) {
        this.menuClickEnable = false;
        this._moveToClousterFourZoneTwo();
      }
    });
    this.twoClousterFive.addEventListener("click", () => {
      if (this.menuClickEnable) {
        this.menuClickEnable = false;
        this._moveToClousterFiveZoneTwo();
      }
    });
    this.twoClousterSix.addEventListener("click", () => {
      if (this.menuClickEnable) {
        this.menuClickEnable = false;
        this._moveToClousterSixZoneTwo();
      }
    });

    this.threeClousterOne.addEventListener("click", () => {
      if (this.menuClickEnable) {
        this.menuClickEnable = false;
        this._moveToClousterOneZoneThree();
      }
    });
    this.threeClousterTwo.addEventListener("click", () => {
      if (this.menuClickEnable) {
        this.menuClickEnable = false;
        this._moveToClousterTwoZoneThree();
      }
    });

    this.fiveClousterOne.addEventListener("click", () => {
      if (this.menuClickEnable) {
        this.menuClickEnable = false;
        this._moveToClousterOneZoneFive();
      }
    });
    this.fiveClousterTwo.addEventListener("click", () => {
      if (this.menuClickEnable) {
        this.menuClickEnable = false;
        this._moveToClousterTwoZoneFive();
      }
    });
    this.fiveClousterThree.addEventListener("click", () => {
      if (this.menuClickEnable) {
        this.menuClickEnable = false;
        this._moveToClousterThreeZoneFive();
      }
    });
    this.fiveClousterFour.addEventListener("click", () => {
      if (this.menuClickEnable) {
        this.menuClickEnable = false;
        this._moveToClousterFourZoneFive();
      }
    });
    this.sixClousterOne.addEventListener("click", () => {
      if (this.menuClickEnable) {
        this.menuClickEnable = false;
        this._moveToClousterOneZoneSix();
      }
    });
    this.sixClousterTwo.addEventListener("click", () => {
      if (this.menuClickEnable) {
        this.menuClickEnable = false;
        this._moveToClousterTwoZoneSix();
      }
    });

    this.sixClousterThree.addEventListener("click", () => {
      if (this.menuClickEnable) {
        this.menuClickEnable = false;
        this._moveToClousterThreeZoneSix();
      }
    });
    this.sevenClousterOne.addEventListener("click", () => {
      if (this.menuClickEnable) {
        this.menuClickEnable = false;
        this._moveToClousterOneZoneSeven();
      }
    });
    this.sevenClousterTwo.addEventListener("click", () => {
      if (this.menuClickEnable) {
        this.menuClickEnable = false;
        this._moveToClousterTwoZoneSeven();
      }
    });
    this.sevenClousterThree.addEventListener("click", () => {
      if (this.menuClickEnable) {
        this.menuClickEnable = false;
        this._moveToClousterThreeZoneSeven();
      }
    });

    this.eightClousterOne.addEventListener("click", () => {
      if (this.menuClickEnable) {
        this.menuClickEnable = false;
        this._moveToClousterThreeZoneEight();
      }
    });
    this.eightClousterTwo.addEventListener("click", () => {
      if (this.menuClickEnable) {
        this.menuClickEnable = false;
        this._moveToClousterOneZoneEight();
      }
    });
    this.eightClousterThree.addEventListener("click", () => {
      if (this.menuClickEnable) {
        this.menuClickEnable = false;
        this._moveToClousterTwoZoneEight();
      }
    });
    this.eightClousterFour.addEventListener("click", () => {
      if (this.menuClickEnable) {
        this.menuClickEnable = false;
        this._moveToClousterFourZoneEight();
      }
    });
    this.eightClousterFive.addEventListener("click", () => {
      if (this.menuClickEnable) {
        this.menuClickEnable = false;
        this._moveToClousterFiveZoneEight();
      }
    });

    //
    this.menuZoneOne.addEventListener("click", () => {
      if (this.menuClickEnable) {
        this.menuClickEnable = false;
        this._moveToZoneOne();
      }
    });
    this.menuZoneTwo.addEventListener("click", () => {
      if (this.menuClickEnable) {
        this.menuClickEnable = false;
        this._moveToZoneTwo();
      }
    });
    this.menuZoneThree.addEventListener("click", () => {
      if (this.menuClickEnable) {
        this.menuClickEnable = false;
        this._moveToZoneThree();
      }
    });
    this.menuZoneFour.addEventListener("click", () => {
      if (this.menuClickEnable) {
        this.menuClickEnable = false;
        this._moveToZoneFour();
      }
    });
    this.menuZoneFive.addEventListener("click", () => {
      if (this.menuClickEnable) {
        this.menuClickEnable = false;
        this._moveToZoneFive();
      }
    });
    this.menuZoneSix.addEventListener("click", () => {
      if (this.menuClickEnable) {
        this.menuClickEnable = false;
        this._moveToZoneSix();
      }
    });
    this.menuZoneSeven.addEventListener("click", () => {
      if (this.menuClickEnable) {
        this.menuClickEnable = false;
        this._moveToZoneSeven();
      }
    });
    this.menuZoneEight.addEventListener("click", () => {
      if (this.menuClickEnable) {
        this.menuClickEnable = false;
        this._moveToZoneEight();
      }
    });
    // click show label
    // this.mediumCircles.map(zone =>{
    //     zone.addEventListener()
    // })
    //
  }

  colorizeMedumCircle(zoneToZolorize) {
    this.mediumCircles.map((zone) => {
      if (zone === zoneToZolorize) {
        zone.classList.remove("bg-DFDFDF");
        zone.classList.remove("bg-7c9fa5");
        zone.classList.remove("hover:bg-7c9fa5");
        zone.classList.add("bg-004858");
      } else {
        zone.classList.remove("bg-004858");
        zone.classList.remove("bg-7c9fa5");
        zone.classList.add("hover:bg-7c9fa5");
        zone.classList.add("bg-DFDFDF");
      }
    });
  }
  colorizeClousterCircle(clousterToColorize) {
    this.cloustersCircles.map((clouster) => {
      if (clouster === clousterToColorize) {
        clouster.classList.remove("bg-DFDFDF");
        clouster.classList.remove("bg-7c9fa5");
        clouster.classList.remove("hover:bg-7c9fa5");
        clouster.classList.add("bg-004858");
      } else {
        clouster.classList.remove("bg-004858");
        clouster.classList.remove("bg-7c9fa5");
        clouster.classList.add("hover:bg-7c9fa5");
        clouster.classList.add("bg-DFDFDF");
      }
    });
  }

  hoverModelColorizeMedumCircle(zoneToShow) {
    if (zoneToShow) {
      this.labelsZones.map((zone) => {
        if (zone === zoneToShow) {
          zone.parentElement.classList.remove("bg-DFDFDF");
          zone.parentElement.classList.remove("bg-004858");
          zone.parentElement.classList.add("bg-7c9fa5");
          zone.parentElement.classList.remove("text-0e4957");
          zone.parentElement.classList.add("text-white");
          // zone.classList.remove("childVisible")
        } else {
          zone.parentElement.classList.remove("bg-7c9fa5");
          zone.parentElement.classList.remove("bg-004858");
          zone.parentElement.classList.add("bg-DFDFDF");
          zone.parentElement.classList.remove("text-white");
          zone.parentElement.classList.add("text-0e4957");
          // zone.classList.add("childVisible")
        }
      });
    }
  }
  hoverModelColorizeClousterCircle(clousterToShow) {
    this.labelClousters.map((clouster) => {
      if (clouster === clousterToShow) {
        clouster.parentElement.classList.remove("bg-DFDFDF");
        clouster.parentElement.classList.remove("bg-004858");
        clouster.parentElement.classList.add("bg-7c9fa5");
        clouster.parentElement.classList.remove("text-0e4957");
        clouster.parentElement.classList.add("text-white");
        // clouster.classList.remove("childVisible")
      } else {
        clouster.parentElement.classList.remove("bg-7c9fa5");
        clouster.parentElement.classList.remove("bg-004858");
        clouster.parentElement.classList.add("bg-DFDFDF");
        clouster.parentElement.classList.remove("text-white");
        clouster.parentElement.classList.add("text-0e4957");
        // clouster.classList.add("childVisible")
      }
    });
  }
  ChnageColorLabelClouster(clousterToShow) {
    this.labelClousters.map((clouster) => {
      if (clouster === clousterToShow) {
        clouster.parentElement.classList.remove("text-0e4957");
        clouster.parentElement.classList.add("text-white");
      } else {
        clouster.parentElement.classList.remove("text-white");
        clouster.parentElement.classList.add("text-0e4957");
      }
    });
  }

  ShowOneZoneCloustersMenu(zoneNot) {
    [
      this.menuZoneOneClousters,
      this.menuZoneTwoClousters,
      this.menuZoneThreeClousters,
      this.menuZoneFourClousters,
      this.menuZoneFiveClousters,
      this.menuZoneSixClousters,
      this.menuZoneSevenClousters,
      this.menuZoneEightClousters,
    ].map((zone) => {
      if (zone === zoneNot) {
        zone.classList.replace("hidden", "flex");
      } else {
        zone.classList.replace("flex", "hidden");
      }
    });
  }
  moveToGeneralView(time = 1) {
    this.control.enableRotate = true;
    this.control.enablePan = false;
    this.gltf.toggleAllLotes(false);
    this.modalLotesinClouster.hiddenCompleteModal();
    this.gltfMaps.onchangeVisibleModel(true);
    this.accesosSwitch.classList.replace("hidden", "flex");
    this.control.maxDistance = 1200;
    this.control.minDistance = 300;
    this.control.maxPan = new Vector3(1000, 1000, 1000);
    this.control.minPan = new Vector3(-1000, -1000, -1000);
    this.camera.near = 5;
    this.camera.far = 2500;
    this.control.enabled = true;
    this.topCamera = true;
    this._leveCamera = 0;
    this.zoneModalInfo.hideModal({});
    this.modalAngelopolis.showModal();
    this.hoverModelColorizeMedumCircle({});
    this.colorizeMedumCircle({});
    this.moveCameraTo(
      { x: 331.155, y: 1519.97, z: -314.439 },
      { x: -1.56, y: 0, z: 0.028 },
      time,
      () => {
        this.control.target.set(331, 400, -320);
        this.control.enablePan = true;
        this.allMenuZones.classList.replace("hidden", "flex");
      }
    );
    this.ShowOneZoneCloustersMenu({});
  }

  _moveToZoneOne() {
    this.gltfMaps.onchangeVisibleModel(false);
    this.accesosSwitch.classList.replace("flex", "hidden");
    this.modalLotesinClouster.hiddenCompleteModal();
    this.control.enabled = false;
    this.control.minDistance = 4;
    this.control.maxPan = new Vector3(1000, 1000, 1000);
    this.control.minPan = new Vector3(-1000, -1000, -1000);
    this.control.maxDistance = 750;
    this.camera.near = 5;
    this.gltf.hoverZones("", this);
    this.gltf.toggleAllLotes(true);
    this.hoverModelColorizeMedumCircle(this.labelZoneOne);
    this.colorizeMedumCircle(this.menuZoneOne);
    this.ChnageColorLabelClouster({});
    this.colorizeClousterCircle({});
    this.zoneModalInfo.showModal("City Lomas");
    this.modalAngelopolis.hideModal();
    this.topCamera = true;
    this._leveCamera = 1;
    this.moveCameraTo(
      { x: 13.453, y: 131.777, z: -57.341 },
      { x: -1.51, y: 0.0, z: -0.006 }
    );
    this.control.target.set(13.5, -4.8, -65.6);
    this.ShowOneZoneCloustersMenu(this.menuZoneOneClousters);
    // this.hiddenZoneClousters(this.menuZoneTwoClousters)
  }
  _moveToZoneTwo() {
    this.gltfMaps.onchangeVisibleModel(false);
    this.accesosSwitch.classList.replace("flex", "hidden");
    this.modalLotesinClouster.hiddenCompleteModal();
    this.control.enabled = false;
    this.control.minDistance = 4;
    this.control.maxPan = new Vector3(1000, 1000, 1000);
    this.control.minPan = new Vector3(-1000, -1000, -1000);
    this.control.maxDistance = 750;
    this.camera.near = 5;
    this.gltf.hoverZones("", this);
    this.gltf.toggleAllLotes(true);
    this.hoverModelColorizeMedumCircle(this.labelZoneTwo);
    this.colorizeMedumCircle(this.menuZoneTwo);
    this.ChnageColorLabelClouster({});
    this.colorizeClousterCircle({});
    this.zoneModalInfo.showModal("Cascatta IIB");
    this.modalAngelopolis.hideModal();
    this.topCamera = true;
    this._leveCamera = 1;
    this.moveCameraTo(
      { x: 137.173, y: 97.057, z: -28.158 },
      { x: -1.381, y: -0.011, z: -0.057 }
    );
    this.control.target.set(138.3, -4.7, -47.7);
    this.ShowOneZoneCloustersMenu(this.menuZoneTwoClousters);
    // this.hiddenZoneClousters(this.menuZoneOneClousters)
  }
  _moveToZoneThree() {
    this.gltfMaps.onchangeVisibleModel(false);
    this.accesosSwitch.classList.replace("flex", "hidden");
    this.modalLotesinClouster.hiddenCompleteModal();
    this.control.enabled = false;
    this.control.minDistance = 4;
    this.control.maxPan = new Vector3(1000, 1000, 1000);
    this.control.minPan = new Vector3(-1000, -1000, -1000);
    this.control.maxDistance = 750;
    this.camera.near = 5;
    this.gltf.hoverZones("", this);
    this.gltf.toggleAllLotes(true);
    this.ShowOneZoneCloustersMenu(this.menuZoneThreeClousters);
    this.hoverModelColorizeMedumCircle(this.labelZoneThree);
    this.colorizeMedumCircle(this.menuZoneThree);
    this.ChnageColorLabelClouster({});
    this.colorizeClousterCircle({});
    this.zoneModalInfo.showModal("Cascatta II");
    this.modalAngelopolis.hideModal();
    this.topCamera = true;
    this._leveCamera = 1;
    this.moveCameraTo(
      { x: 48.617, y: 172.25, z: -151.199 },
      { x: -1.552, y: 0.001, z: 0.048 }
    );
    this.control.target.set(48.45, -8.62, -154.6);
  }
  _moveToZoneFour() {
    this.gltfMaps.onchangeVisibleModel(false);
    this.accesosSwitch.classList.replace("flex", "hidden");
    this.modalLotesinClouster.hiddenCompleteModal();
    this.control.enabled = false;
    this.control.minDistance = 4;
    this.control.maxPan = new Vector3(1000, 1000, 1000);
    this.control.minPan = new Vector3(-1000, -1000, -1000);
    this.control.maxDistance = 750;
    this.camera.near = 5;
    this.gltf.hoverZones("", this);
    this.gltf.toggleAllLotes(true);
    this.hoverModelColorizeMedumCircle(this.labelZoneFour);
    this.colorizeMedumCircle(this.menuZoneFour);
    this.ChnageColorLabelClouster({});
    this.colorizeClousterCircle({});
    this.zoneModalInfo.showModal("Lomas I y II");
    this.modalAngelopolis.hideModal();
    this.topCamera = true;
    this._leveCamera = 1;
    this.moveCameraTo(
      { x: 111.278, y: 281.214, z: -433.267 },
      { x: -1.527, y: -0.0, z: -0.005 }
    );
    this.control.target.set(111.34, -7.7, -445.8);
    this.ShowOneZoneCloustersMenu(this.menuZoneFourClousters);
  }
  _moveToZoneFive() {
    this.gltfMaps.onchangeVisibleModel(false);
    this.accesosSwitch.classList.replace("flex", "hidden");
    this.modalLotesinClouster.hiddenCompleteModal();
    this.control.enabled = false;
    this.control.minDistance = 4;
    this.control.maxPan = new Vector3(1000, 1000, 1000);
    this.control.minPan = new Vector3(-1000, -1000, -1000);
    this.control.maxDistance = 750;
    this.camera.near = 5;
    this.gltf.hoverZones("", this);
    this.gltf.toggleAllLotes(true);
    this.hoverModelColorizeMedumCircle(this.labelZoneFive);
    this.colorizeMedumCircle(this.menuZoneFive);
    this.ShowOneZoneCloustersMenu(this.menuZoneFiveClousters);
    this.ChnageColorLabelClouster({});
    this.colorizeClousterCircle({});
    this.zoneModalInfo.showModal("Toscana II");
    this.modalAngelopolis.hideModal();
    this.topCamera = true;
    this._leveCamera = 1;
    this.moveCameraTo(
      { x: 35.572, y: 108.482, z: -438.143 },
      { x: -1.476, y: 0.008, z: 0.086 }
    );
    this.control.target.set(34.64, -4.7, -448.94);
  }
  _moveToZoneSix() {
    this.gltfMaps.onchangeVisibleModel(false);
    this.accesosSwitch.classList.replace("flex", "hidden");
    this.modalLotesinClouster.hiddenCompleteModal();
    this.control.enabled = false;
    this.control.minDistance = 4;
    this.control.maxPan = new Vector3(1000, 1000, 1000);
    this.control.minPan = new Vector3(-1000, -1000, -1000);
    this.control.maxDistance = 750;
    this.camera.near = 5;
    this.gltf.hoverZones("", this);
    this.gltf.toggleAllLotes(true);
    this.hoverModelColorizeMedumCircle(this.labelZoneSix);
    this.colorizeMedumCircle(this.menuZoneSix);
    this.ShowOneZoneCloustersMenu(this.menuZoneSixClousters);
    this.ChnageColorLabelClouster({});
    this.colorizeClousterCircle({});
    this.zoneModalInfo.showModal("Distrito Escolar");
    this.modalAngelopolis.hideModal();
    this.topCamera = true;
    this._leveCamera = 1;
    this.moveCameraTo(
      { x: 29.986, y: 75.561, z: -349.729 },
      { x: -1.374, y: -0.011, z: -0.054 }
    );
    this.control.target.set(31.12, -26.72, -370.66);
  }
  _moveToZoneSeven() {
    this.gltfMaps.onchangeVisibleModel(false);
    this.accesosSwitch.classList.replace("flex", "hidden");
    this.modalLotesinClouster.hiddenCompleteModal();
    this.control.enabled = false;
    this.control.minDistance = 4;
    this.control.maxPan = new Vector3(1000, 1000, 1000);
    this.control.minPan = new Vector3(-1000, -1000, -1000);
    this.control.maxDistance = 750;
    this.camera.near = 5;
    this.gltf.hoverZones("", this);
    this.gltf.toggleAllLotes(true);
    this.hoverModelColorizeMedumCircle(this.labelZoneSeven);
    this.colorizeMedumCircle(this.menuZoneSeven);
    this.ShowOneZoneCloustersMenu(this.menuZoneSevenClousters);
    this.ChnageColorLabelClouster({});
    this.colorizeClousterCircle({});
    this.zoneModalInfo.showModal("Cascata I");
    this.modalAngelopolis.hideModal();
    this.topCamera = true;
    this._leveCamera = 1;
    this.moveCameraTo(
      { x: 66.877, y: 139.854, z: -214.116 },
      { x: -1.552, y: 0.001, z: 0.048 }
    );
    this.control.target.set(66.74, -7.47, -216.89);
  }
  _moveToCascattaI() {
    this.gltfMaps.onchangeVisibleModel(false);
    this.accesosSwitch.classList.replace("flex", "hidden");
    this.modalLotesinClouster.hiddenCompleteModal();
    this.control.enabled = false;
    this.control.minDistance = 4;
    this.control.maxPan = new Vector3(1000, 1000, 1000);
    this.control.minPan = new Vector3(-1000, -1000, -1000);
    this.control.maxDistance = 750;
    this.camera.near = 5;
    this.gltf.hoverZones("", this);
    this.ChnageColorLabelClouster({});
    this.colorizeClousterCircle({});
    this.zoneModalInfo.showModal("Cascatta I");
    this.modalAngelopolis.hideModal();
    this.topCamera = true;
    this._leveCamera = 1;
    this.moveCameraTo(
      { x: 72.922, y: 173.641, z: -226.757 },
      { x: -1.56, y: 0.0, z: 0.001 }
    );
    this.control.target.set(72.92, -7.25, -228.63);
  }
  _moveToZoneZoneAzul() {
    this.gltfMaps.onchangeVisibleModel(false);
    this.accesosSwitch.classList.replace("flex", "hidden");
    this.modalLotesinClouster.hiddenCompleteModal();
    this.control.enabled = false;
    this.control.minDistance = 4;
    this.control.maxPan = new Vector3(1000, 1000, 1000);
    this.control.minPan = new Vector3(-1000, -1000, -1000);
    this.control.maxDistance = 750;
    this.camera.near = 5;
    this.gltf.hoverZones("", this);
    this.ChnageColorLabelClouster({});
    this.colorizeClousterCircle({});
    this.zoneModalInfo.showModal("Zona Azul");
    this.modalAngelopolis.hideModal();
    this.topCamera = true;
    this._leveCamera = 1;
    this.moveCameraTo(
      { x: 56.804, y: 129.028, z: -347.786 },
      { x: -1.385, y: 0.015, z: 0.078 }
    );
    this.control.target.set(54.47, -26.04, -376.99);
  }
  _moveToLomasII() {
    this.gltfMaps.onchangeVisibleModel(false);
    this.accesosSwitch.classList.replace("flex", "hidden");
    this.modalLotesinClouster.hiddenCompleteModal();
    this.control.enabled = false;
    this.control.minDistance = 4;
    this.control.maxPan = new Vector3(1000, 1000, 1000);
    this.control.minPan = new Vector3(-1000, -1000, -1000);
    this.control.maxDistance = 750;
    this.camera.near = 5;
    this.gltf.hoverZones("", this);
    this.ChnageColorLabelClouster({});
    this.colorizeClousterCircle({});
    this.zoneModalInfo.showModal("Lomas 2");
    this.modalAngelopolis.hideModal();
    this.topCamera = true;
    this._leveCamera = 1;
    this.moveCameraTo(
      { x: 100.932, y: 188.393, z: -434.438 },
      { x: -1.455, y: 0, z: -0.002 }
    );
    this.control.target.set(100.99, -22.25, -458.99);
  }
  _moveToLomasI() {
    this.gltfMaps.onchangeVisibleModel(false);
    this.accesosSwitch.classList.replace("flex", "hidden");
    this.modalLotesinClouster.hiddenCompleteModal();
    this.control.enabled = false;
    this.control.minDistance = 4;
    this.control.maxPan = new Vector3(1000, 1000, 1000);
    this.control.minPan = new Vector3(-1000, -1000, -1000);
    this.control.maxDistance = 750;
    this.camera.near = 5;
    this.gltf.hoverZones("", this);
    this.ChnageColorLabelClouster({});
    this.colorizeClousterCircle({});
    this.zoneModalInfo.showModal("Lomas 1");
    this.modalAngelopolis.hideModal();
    this.topCamera = true;
    this._leveCamera = 1;
    this.moveCameraTo(
      { x: 207.547, y: 215.97, z: -472.888 },
      { x: -1.455, y: 0, z: -0.002 }
    );
    this.control.target.set(207.61, -17.43, -500.09);
  }
  _moveToZoneEight() {
    this.gltfMaps.onchangeVisibleModel(false);
    this.accesosSwitch.classList.replace("flex", "hidden");
    this.modalLotesinClouster.hiddenCompleteModal();
    this.control.enabled = false;
    this.control.minDistance = 4;
    this.control.maxPan = new Vector3(1000, 1000, 1000);
    this.control.minPan = new Vector3(-1000, -1000, -1000);
    this.control.maxDistance = 750;
    this.camera.near = 5;
    this.gltf.hoverZones("", this);
    this.gltf.toggleAllLotes(true);
    this.hoverModelColorizeMedumCircle(this.labelZoneEight);
    this.colorizeMedumCircle(this.menuZoneEight);
    this.ShowOneZoneCloustersMenu(this.menuZoneEightClousters);
    this.ChnageColorLabelClouster({});
    this.colorizeClousterCircle({});
    this.zoneModalInfo.showModal("La Strada");
    this.modalAngelopolis.hideModal();
    this.topCamera = true;
    this._leveCamera = 1;
    this.moveCameraTo(
      { x: -45.451, y: 113.315, z: 84.589 },
      { x: -1.552, y: 0.001, z: 0.049 }
    );
    this.control.target.set(-45.57, -13, 82.21);
  }

  clickZones(name) {
    this.directional.color = new Color(0xffffff);
    this.directional.position.x = 12;
    switch (name) {
      case "Terreno_cascatta2_MT_G_terreno_0":
        this._moveToZoneOne();
        // this._moveToZoneThree();
        break;
      case "Sin_lotes_MT_G_terreno_0":
        this._moveToZoneFour();
        break;
      case "Terreno_nuevaZona_MT_G_terreno_0":
        this._moveToZoneOne();
        break;
      case "Terreno_nuevaZona2_MT_G_terreno_0":
        this._moveToZoneTwo();
        break;
      case "Terreno_parques_MT_G_terreno_0":
        this._moveToZoneFive();
        break;
      case "Distrito_escolar_MT_G_terreno_0001":
        this._moveToZoneSix();
        break;
      case "Terreno_cascatta":
        this._moveToZoneSeven();
        break;
      case "Terreno_nuevaZona_3":
        this._moveToZoneEight();
        break;

      case "Terreno_cascatta_MT_G_terreno_0":
        this._moveToCascattaI();
        break;
      case "Zona_Azul_MT_G_terreno_0":
        this._moveToZoneZoneAzul();
        break;
      case "Lomas2_MT_G_terreno_0":
        this._moveToLomasII();
        break;
      case "Lomas1_MT_G_terreno_0":
        this._moveToLomasI();
        break;
    }
  }
  clickClouster(name) {
    this.directional.color = new Color(0xe2e2e2);
    this.directional.position.x = 2;
    switch (name) {
      case "Banqueta_fontana_MT_G_terreno_0":
        this.hoverModelColorizeMedumCircle(this.labelZoneOne);
        this.colorizeMedumCircle(this.menuZoneOne);
        this.ShowOneZoneCloustersMenu(this.menuZoneOneClousters);
        this._moveToClousterOne();
        break;
      case "Banqueta_sacramento_MT_G_terreno_0":
        this.hoverModelColorizeMedumCircle(this.labelZoneOne);
        this.colorizeMedumCircle(this.menuZoneOne);
        this.ShowOneZoneCloustersMenu(this.menuZoneOneClousters);
        this._moveToClousterTwo();
        break;
      case "Banqueta_arcadia_MT_G_terreno_0":
        this.hoverModelColorizeMedumCircle(this.labelZoneOne);
        this.colorizeMedumCircle(this.menuZoneOne);
        this.ShowOneZoneCloustersMenu(this.menuZoneOneClousters);
        this._moveToClousterThree();
        break;
      case "Banqueta_rinconada_MT_G_terreno_0":
        this.hoverModelColorizeMedumCircle(this.labelZoneOne);
        this.colorizeMedumCircle(this.menuZoneOne);
        this.ShowOneZoneCloustersMenu(this.menuZoneOneClousters);
        this._moveToClousterFour();
        break;
      case "Galena4":
        this.hoverModelColorizeMedumCircle(this.labelZoneOne);
        this.colorizeMedumCircle(this.menuZoneOne);
        this.ShowOneZoneCloustersMenu(this.menuZoneOneClousters);
        this._moveToClousterFive();
        break;
      case "Banqueta_Milos":
        this.hoverModelColorizeMedumCircle(this.labelZoneOne);
        this.colorizeMedumCircle(this.menuZoneOne);
        this.ShowOneZoneCloustersMenu(this.menuZoneOneClousters);
        this._moveToClousterSix();
        break;
      case "Banqueta_capri_MT_G_terreno_0":
        this.hoverModelColorizeMedumCircle(this.labelZoneTwo);
        this.colorizeMedumCircle(this.menuZoneTwo);
        this.ShowOneZoneCloustersMenu(this.menuZoneTwoClousters);
        this._moveToClousterOneZoneTwo();
        break;
      case "Banqueta_Creta_MT_G_terreno_0":
        this.hoverModelColorizeMedumCircle(this.labelZoneTwo);
        this.colorizeMedumCircle(this.menuZoneTwo);
        this.ShowOneZoneCloustersMenu(this.menuZoneTwoClousters);
        this._moveToClousterTwoZoneTwo();
        break;
      case "Banqueta_rodas_MT_G_terreno_0":
        this.hoverModelColorizeMedumCircle(this.labelZoneTwo);
        this.colorizeMedumCircle(this.menuZoneTwo);
        this.ShowOneZoneCloustersMenu(this.menuZoneTwoClousters);
        this._moveToClousterThreeZoneTwo();
        break;
      case "Banqueta_bali_MT_G_terreno_0":
        this.hoverModelColorizeMedumCircle(this.labelZoneTwo);
        this.colorizeMedumCircle(this.menuZoneTwo);
        this.ShowOneZoneCloustersMenu(this.menuZoneTwoClousters);
        this._moveToClousterFourZoneTwo();
        break;
      case "Banqueta_niza":
        this.hoverModelColorizeMedumCircle(this.labelZoneTwo);
        this.colorizeMedumCircle(this.menuZoneTwo);
        this.ShowOneZoneCloustersMenu(this.menuZoneTwoClousters);
        this._moveToClousterFiveZoneTwo();
        break;
      case "Banqueta_antalya":
        this.hoverModelColorizeMedumCircle(this.labelZoneTwo);
        this.colorizeMedumCircle(this.menuZoneTwo);
        this.ShowOneZoneCloustersMenu(this.menuZoneTwoClousters);
        this._moveToClousterSixZoneTwo();
        break;
      case "Banqueta_vilansa_MT_G_terreno_0":
        this.ShowOneZoneCloustersMenu(this.menuZoneThreeClousters);
        this.colorizeMedumCircle(this.menuZoneThree);
        this.hoverModelColorizeMedumCircle(this.labelZoneThree);
        this._moveToClousterOneZoneThree();
        break;
      case "Banqueta_zante":
        this.ShowOneZoneCloustersMenu(this.menuZoneThreeClousters);
        this.colorizeMedumCircle(this.menuZoneThree);
        this.hoverModelColorizeMedumCircle(this.labelZoneThree);
        this._moveToClousterTwoZoneThree();
        break;
      case "Banqueta_parqueViena_MT_G_terreno_0":
        this.hoverModelColorizeMedumCircle(this.labelZoneFive);
        this.colorizeMedumCircle(this.menuZoneFive);
        this.ShowOneZoneCloustersMenu(this.menuZoneFiveClousters);
        this._moveToClousterOneZoneFive();
        break;
      case "Banqueta_parqueBerna_MT_G_terreno_0":
        this.hoverModelColorizeMedumCircle(this.labelZoneFive);
        this.colorizeMedumCircle(this.menuZoneFive);
        this.ShowOneZoneCloustersMenu(this.menuZoneFiveClousters);
        this._moveToClousterTwoZoneFive();
        break;
      case "Banqueta_sofia_MT_G_terreno_0":
        this.hoverModelColorizeMedumCircle(this.labelZoneFive);
        this.colorizeMedumCircle(this.menuZoneFive);
        this.ShowOneZoneCloustersMenu(this.menuZoneFiveClousters);
        this._moveToClousterThreeZoneFive();
        break;
      case "Banqueta_palermo_MT_G_terreno_0":
        this.hoverModelColorizeMedumCircle(this.labelZoneFive);
        this.colorizeMedumCircle(this.menuZoneFive);
        this.ShowOneZoneCloustersMenu(this.menuZoneFiveClousters);
        this._moveToClousterFourZoneFive();
        break;
      case "Banqueta_anturio_MT_G_terreno_0":
        this.hoverModelColorizeMedumCircle(this.labelZoneSix);
        this.colorizeMedumCircle(this.menuZoneSix);
        this.ShowOneZoneCloustersMenu(this.menuZoneSixClousters);
        this._moveToClousterOneZoneSix();
        break;
      case "Banqueta_balcanes":
        this.hoverModelColorizeMedumCircle(this.labelZoneSix);
        this.colorizeMedumCircle(this.menuZoneSix);
        this.ShowOneZoneCloustersMenu(this.menuZoneSixClousters);
        this._moveToClousterTwoZoneSix();
        break;
      case "Banqueta_lucerna":
        this.hoverModelColorizeMedumCircle(this.labelZoneSeven);
        this.colorizeMedumCircle(this.menuZoneSeven);
        this.ShowOneZoneCloustersMenu(this.menuZoneSevenClousters);
        this._moveToClousterOneZoneSeven();
        break;
      case "Banqueta_lacantera":
        this.hoverModelColorizeMedumCircle(this.labelZoneSeven);
        this.colorizeMedumCircle(this.menuZoneSeven);
        this.ShowOneZoneCloustersMenu(this.menuZoneSevenClousters);
        this._moveToClousterTwoZoneSeven();
        break;
      case "Banqueta_TerraVerde":
        this.hoverModelColorizeMedumCircle(this.labelZoneSeven);
        this.colorizeMedumCircle(this.menuZoneSeven);
        this.ShowOneZoneCloustersMenu(this.menuZoneSevenClousters);
        this._moveToClousterThreeZoneSeven();
        break;

      case "Banqueta_verona":
        this.hoverModelColorizeMedumCircle(this.labelZoneEight);
        this.colorizeMedumCircle(this.menuZoneEight);
        this.ShowOneZoneCloustersMenu(this.menuZoneEightClousters);
        this._moveToClousterOneZoneEight();
        break;
      case "Banqueta_sorrento":
        this.hoverModelColorizeMedumCircle(this.labelZoneEight);
        this.colorizeMedumCircle(this.menuZoneEight);
        this.ShowOneZoneCloustersMenu(this.menuZoneEightClousters);
        this._moveToClousterTwoZoneEight();
        break;
      case "Banqueta_trento":
        this.hoverModelColorizeMedumCircle(this.labelZoneEight);
        this.colorizeMedumCircle(this.menuZoneEight);
        this.ShowOneZoneCloustersMenu(this.menuZoneEightClousters);
        this._moveToClousterThreeZoneEight();
        break;
      case "Banqueta_Ferrara":
        this.hoverModelColorizeMedumCircle(this.labelZoneEight);
        this.colorizeMedumCircle(this.menuZoneEight);
        this.ShowOneZoneCloustersMenu(this.menuZoneEightClousters);
        this._moveToClousterFourZoneEight();
        break;
      case "Banqueta_Siena":
        this.hoverModelColorizeMedumCircle(this.labelZoneEight);
        this.colorizeMedumCircle(this.menuZoneEight);
        this.ShowOneZoneCloustersMenu(this.menuZoneEightClousters);
        this._moveToClousterFiveZoneEight();
        break;
      case "Banqueta_Montenegro":
        this.hoverModelColorizeMedumCircle(this.labelZoneSix);
        this.colorizeMedumCircle(this.menuZoneSix);
        this.ShowOneZoneCloustersMenu(this.menuZoneSixClousters);
        this._moveToClousterThreeZoneSix();
        break;
    }
  }

  changeMaxPandControl(distance = 10) {
    const maxPan = new Vector3(
      this.control.target.x + distance,
      this.control.target.y + 1,
      this.control.target.z + distance
    );
    const minPan = new Vector3(
      this.control.target.x - distance,
      this.control.target.y - 1,
      this.control.target.z - distance
    );
    this.control.maxPan = maxPan;
    this.control.minPan = minPan;
  }

  _moveToClousterOne() {
    this.control.enabled = true;
    this.control.maxDistance = 30;
    this.gltf.hoverClousters("", this);
    this.zoneModalInfo.showModal("Fontana", true);
    this.modalLotesinClouster.showCompleteModal("Fontana");
    this.ChnageColorLabelClouster(this.labelClousterOne);
    this.moveCameraTo(
      { x: 1.2, y: 16.69, z: -6.746 },
      { x: -1.204, y: -0.066, z: -0.171 }
    );
    this.control.target.set(2.73, -4.8, -15);
    this.camera.near = 0.1;
    this.changeMaxPandControl();
    this.control.enablePan = true;
    this.control.enableRotate = true;
    this.topCamera = false;
    this.colorizeClousterCircle(this.oneClousterOne);
  }
  _moveToClousterTwo() {
    this.control.enabled = true;
    this.control.maxDistance = 30;
    this.gltf.hoverClousters("", this);
    this.zoneModalInfo.showModal("Sacramento", true);
    this.modalLotesinClouster.showCompleteModal("Sacramento");
    this.colorizeClousterCircle(this.oneClousterTwo);
    this.ChnageColorLabelClouster(this.labelClousterTwo);
    this.moveCameraTo(
      { x: 12.7, y: 12.8, z: -15.1 },
      { x: -0.948, y: 0.027, z: 0.038 }
    );
    this.control.target.set(12.02, -7.41, -29.62);
    this.camera.near = 0.1;
    this.changeMaxPandControl();
    this.control.enablePan = true;
    this.control.enableRotate = true;
    this.topCamera = false;
  }
  _moveToClousterThree() {
    this.control.enabled = true;
    this.control.maxDistance = 30;
    this.gltf.hoverClousters("", this);
    this.zoneModalInfo.showModal("Arcadia", true);
    this.modalLotesinClouster.showCompleteModal("LIGARCADIA");
    this.colorizeClousterCircle(this.oneClousterThree);
    this.moveCameraTo(
      { x: -8.0, y: 10.95, z: -36.338 },
      { x: -0.768, y: -0.015, z: -0.015 }
    );
    this.control.target.set(-7.62, -6.52, -54.44);
    this.camera.near = 0.1;
    this.changeMaxPandControl();
    this.control.enablePan = true;
    this.control.enableRotate = true;
    this.topCamera = false;
    this.ChnageColorLabelClouster(this.labelClousterThree);
  }
  _moveToClousterFour() {
    this.control.enabled = true;
    this.control.maxDistance = 30;
    this.gltf.hoverClousters("", this);
    this.zoneModalInfo.showModal("Rinconada", true);
    this.modalLotesinClouster.showCompleteModal("Rinconada");
    this.colorizeClousterCircle(this.oneClousterFour);
    this.moveCameraTo(
      { x: 63.47, y: 17.26, z: -52.68 },
      { x: -0.969, y: -0.02, z: -0.029 }
    );
    this.control.target.set(63.97, -3.43, -66.9);
    this.camera.near = 0.1;
    this.changeMaxPandControl();
    this.control.enablePan = true;
    this.control.enableRotate = true;
    this.topCamera = false;
    this.ChnageColorLabelClouster(this.labelClousterFour);
  }
  _moveToClousterFive() {
    this.control.enabled = true;
    this.control.maxDistance = 30;
    this.gltf.hoverClousters("", this);
    this.zoneModalInfo.showModal("Galena", true);
    this.modalLotesinClouster.showCompleteModal("Galena");
    this.colorizeClousterCircle(this.oneClousterFive);
    this.moveCameraTo(
      { x: -15.571, y: 17.231, z: -6.163 },
      { x: -0.972, y: -0.065, z: -0.095 }
    );
    this.control.target.set(-13.82, -4.95, -21.3);
    this.camera.near = 0.1;
    this.changeMaxPandControl();
    this.control.enablePan = true;
    this.control.enableRotate = true;
    this.topCamera = false;
    this.ChnageColorLabelClouster(this.labelClousterFive);
  }
  _moveToClousterSix() {
    this.control.enabled = true;
    this.control.maxDistance = 30;
    this.gltf.hoverClousters("", this);
    this.zoneModalInfo.showModal("Milos", true);
    this.modalLotesinClouster.showCompleteModal("Milos");
    this.colorizeClousterCircle(this.oneClousterSix);
    this.moveCameraTo(
      { x: 53.57, y: 13.499, z: -87.237 },
      { x: -1.349, y: 0.057, z: 0.247 }
    );
    this.control.target.set(52.96, 3.03, -89.6);
    this.camera.near = 0.1;
    this.changeMaxPandControl();
    this.control.enablePan = true;
    this.control.enableRotate = true;
    this.topCamera = false;
    this.ChnageColorLabelClouster(this.oneLabelClousterSix);
  }
  _moveToClousterOneZoneTwo() {
    this.control.enabled = true;
    this.control.maxDistance = 30;
    this.gltf.hoverClousters("", this);
    this.zoneModalInfo.showModal("Capri", true);
    this.modalLotesinClouster.showCompleteModal("Capri");
    this.colorizeClousterCircle(this.twoClousterOne);
    this.moveCameraTo(
      { x: 101.3, y: 4.74, z: -3.56 },
      { x: -0.659, y: 0.189, z: 0.144 }
    );
    this.control.target.set(97.22, -8.36, -20.46);
    this.camera.near = 0.1;
    this.changeMaxPandControl();
    this.control.enablePan = true;
    this.control.enableRotate = true;
    this.topCamera = false;
    this.ChnageColorLabelClouster(this.twoLabelClousterOne);
  }
  _moveToClousterTwoZoneTwo() {
    this.control.enabled = true;
    this.control.maxDistance = 30;
    this.gltf.hoverClousters("", this);
    this.zoneModalInfo.showModal("Creta", true);
    this.modalLotesinClouster.showCompleteModal("Creta");
    this.colorizeClousterCircle(this.twoClousterTwo);
    this.moveCameraTo(
      { x: 119.1, y: 11.9, z: -2.76 },
      { x: -0.892, y: 0.016, z: 0.019 }
    );
    this.control.target.set(118.74, -6, -17.2);
    this.camera.near = 0.1;
    this.changeMaxPandControl();
    this.control.enablePan = true;
    this.control.enableRotate = true;
    this.topCamera = false;
    this.ChnageColorLabelClouster(this.twoLabelClousterTwo);
  }
  _moveToClousterThreeZoneTwo() {
    this.control.enabled = true;
    this.control.maxDistance = 30;
    this.gltf.hoverClousters("", this);
    this.zoneModalInfo.showModal("Rodas", true);
    this.modalLotesinClouster.showCompleteModal("Rodas");
    this.colorizeClousterCircle(this.twoClousterThree);
    this.moveCameraTo(
      { x: 158.3, y: 10.4, z: -21.7 },
      { x: -0.757, y: 0.042, z: 0.04 }
    );
    this.control.target.set(157.13, -8.68, -41.88);
    this.camera.near = 0.1;
    this.changeMaxPandControl();
    this.control.enablePan = true;
    this.control.enableRotate = true;
    this.topCamera = false;
    this.ChnageColorLabelClouster(this.twoLabelClousterThree);
  }
  _moveToClousterFourZoneTwo() {
    this.control.enabled = true;
    this.control.maxDistance = 30;
    this.gltf.hoverClousters("", this);
    this.zoneModalInfo.showModal("Bali", true);
    this.modalLotesinClouster.showCompleteModal("Bali");
    this.colorizeClousterCircle(this.twoClousterFour);
    this.moveCameraTo(
      { x: 148.694, y: 10.049, z: 4.907 },
      { x: -0.879, y: -0.117, z: -0.14 }
    );
    this.control.target.set(152.2, -12.9, -14.09);
    this.camera.near = 0.1;
    this.changeMaxPandControl();
    this.control.enablePan = true;
    this.control.enableRotate = true;
    this.topCamera = false;
    this.ChnageColorLabelClouster(this.twoLabelClousterFour);
  }
  _moveToClousterFiveZoneTwo() {
    this.control.enabled = true;
    this.control.maxDistance = 30;
    this.gltf.hoverClousters("", this);
    this.zoneModalInfo.showModal("Niza", true);
    this.modalLotesinClouster.showCompleteModal("Niza");
    this.colorizeClousterCircle(this.twoClousterFive);
    this.moveCameraTo(
      { x: 104.026, y: 8.926, z: -72.846 },
      { x: -1.168, y: -0.101, z: -0.232 }
    );
    this.control.target.set(105.72, -6.46, -79.41);
    this.camera.near = 0.1;
    this.changeMaxPandControl();
    this.control.enablePan = true;
    this.control.enableRotate = true;
    this.topCamera = false;
    this.ChnageColorLabelClouster(this.twoLabelClousterFive);
  }
  _moveToClousterSixZoneTwo() {
    this.control.enabled = true;
    this.control.maxDistance = 40;
    this.gltf.hoverClousters("", this);
    this.zoneModalInfo.showModal("Antalya", true);
    this.modalLotesinClouster.showCompleteModal("Antalya");
    this.colorizeClousterCircle(this.twoClousterSix);
    this.moveCameraTo(
      { x: 171.319, y: 16.176, z: -74.74 },
      { x: -1.162, y: -0.026, z: -0.059 }
    );
    this.control.target.set(171.82, -1.82, -82.54);
    this.camera.near = 0.1;
    this.changeMaxPandControl();
    this.control.enablePan = true;
    this.control.enableRotate = true;
    this.topCamera = false;
    this.ChnageColorLabelClouster(this.twoLabelClousterSix);
  }

  _moveToClousterOneZoneThree() {
    this.control.enabled = true;
    this.control.maxDistance = 30;
    this.gltf.hoverClousters("", this);
    this.zoneModalInfo.showModal("Vilansa", true);
    this.modalLotesinClouster.showCompleteModal("Vilansa");
    this.colorizeClousterCircle(this.threeClousterOne);
    this.moveCameraTo(
      { x: 130.886, y: 19.38, z: -98.325 },
      { x: -1.004, y: 0.135, z: 0.208 }
    );
    this.control.target.set(126.85, -5.7, -114.28);
    this.camera.near = 0.1;
    this.changeMaxPandControl();
    this.control.enablePan = true;
    this.control.enableRotate = true;
    this.topCamera = false;
    this.ChnageColorLabelClouster(this.threeLabelClousterOne);
  }
  _moveToClousterTwoZoneThree() {
    this.control.enabled = true;
    this.control.maxDistance = 30;
    this.gltf.hoverClousters("", this);
    this.zoneModalInfo.showModal("Zante", true);
    this.modalLotesinClouster.showCompleteModal("Zante");
    this.colorizeClousterCircle(this.threeClousterTwo);
    this.moveCameraTo(
      { x: 103.927, y: 16.276, z: -93.853 },
      { x: -1.004, y: 0.135, z: 0.208 }
    );
    this.control.target.set(101.44, -4.56, -103.78);
    this.camera.near = 0.1;
    this.changeMaxPandControl();
    this.control.enablePan = true;
    this.control.enableRotate = true;
    this.topCamera = false;
    this.ChnageColorLabelClouster(this.threeLabelClousterTwo);
  }
  _moveToClousterOneZoneFive() {
    this.control.enabled = true;
    this.control.maxDistance = 30;
    this.gltf.hoverClousters("", this);
    this.zoneModalInfo.showModal("Parque Viena", true);
    this.modalLotesinClouster.showCompleteModal("Viena");
    this.colorizeClousterCircle(this.fiveClousterOne);
    this.moveCameraTo(
      { x: 54.956, y: 26.309, z: -462.546 },
      { x: -1.32, y: 0.026, z: 0.1 }
    );
    this.control.target.set(54.18, -2.74, -470);
    this.camera.near = 0.1;
    this.changeMaxPandControl();
    this.control.enablePan = true;
    this.control.enableRotate = true;
    this.topCamera = false;
    this.ChnageColorLabelClouster(this.fiveLabelClousterOne);
  }
  _moveToClousterTwoZoneFive() {
    this.control.enabled = true;
    this.control.maxDistance = 30;
    this.gltf.hoverClousters("", this);
    this.zoneModalInfo.showModal("Parque Berna", true);
    this.modalLotesinClouster.showCompleteModal("Berna");
    this.colorizeClousterCircle(this.fiveClousterTwo);
    this.moveCameraTo(
      { x: 38.558, y: 15.302, z: -418.085 },
      { x: -0.999, y: 0.076, z: 0.117 }
    );
    this.control.target.set(36.3, -9.7, -434.19);
    this.camera.near = 0.1;
    this.changeMaxPandControl();
    this.control.enablePan = true;
    this.control.enableRotate = true;
    this.topCamera = false;
    this.ChnageColorLabelClouster(this.fiveLabelClousterTwo);
  }
  _moveToClousterThreeZoneFive() {
    this.control.enabled = true;
    this.control.maxDistance = 30;
    this.gltf.hoverClousters("", this);
    this.zoneModalInfo.showModal("Sofia", true);
    this.modalLotesinClouster.showCompleteModal("Sofia");
    this.colorizeClousterCircle(this.fiveClousterThree);
    this.moveCameraTo(
      { x: 19.469, y: 12.686, z: -417.406 },
      { x: -0.847, y: -0.016, z: -0.018 }
    );
    this.control.target.set(19.89, -7.48, -435.23);
    this.camera.near = 0.1;
    this.changeMaxPandControl();
    this.control.enablePan = true;
    this.control.enableRotate = true;
    this.topCamera = false;
    this.ChnageColorLabelClouster(this.fiveLabelClousterThree);
  }
  _moveToClousterFourZoneFive() {
    this.control.enabled = true;
    this.control.maxDistance = 30;
    this.gltf.hoverClousters("", this);
    this.zoneModalInfo.showModal("Palermo", true);
    this.modalLotesinClouster.showCompleteModal("Palermo");
    this.colorizeClousterCircle(this.fiveClousterFour);
    this.moveCameraTo(
      { x: 3.298, y: 6.375, z: -429.286 },
      { x: -0.808, y: -0.265, z: -0.268 }
    );
    this.control.target.set(8.01, -6.16, -441.26);
    this.camera.near = 0.1;
    this.changeMaxPandControl();
    this.control.enablePan = true;
    this.control.enableRotate = true;
    this.topCamera = false;
    this.ChnageColorLabelClouster(this.fiveLabelClousterFour);
  }
  _moveToClousterOneZoneSix() {
    this.control.enabled = true;
    this.control.maxDistance = 30;
    this.gltf.hoverClousters("", this);
    this.zoneModalInfo.showModal("Anturio", true);
    this.modalLotesinClouster.showCompleteModal("Anturio");
    this.colorizeClousterCircle(this.sixClousterOne);
    this.moveCameraTo(
      { x: 34.776, y: 9.818, z: -396.618 },
      { x: -0.91, y: -0.044, z: -0.056 }
    );
    this.control.target.set(36.05, -13.02, -414.39);
    this.camera.near = 0.1;
    this.changeMaxPandControl();
    this.control.enablePan = true;
    this.control.enableRotate = true;
    this.topCamera = false;
    this.ChnageColorLabelClouster(this.sixLabelClousterOne);
  }
  _moveToClousterTwoZoneSix() {
    this.control.enabled = true;
    this.control.maxDistance = 37;
    this.gltf.hoverClousters("", this);
    this.zoneModalInfo.showModal("Balcanes", true);
    this.modalLotesinClouster.showCompleteModal("Balcanes");
    this.colorizeClousterCircle(this.sixClousterTwo);
    this.moveCameraTo(
      { x: 14.365, y: 12.115, z: -364.692 },
      { x: -0.89, y: 0.024, z: 0.029 }
    );
    this.control.target.set(13.46, -17.4, -388.61);
    this.camera.near = 0.1;
    this.changeMaxPandControl();
    this.control.enablePan = true;
    this.control.enableRotate = true;
    this.topCamera = false;
    this.ChnageColorLabelClouster(this.sixLabelClousterTwo);
  }
  _moveToClousterThreeZoneSix() {
    this.control.enabled = true;
    this.control.maxDistance = 60;
    this.gltf.hoverClousters("", this);
    this.zoneModalInfo.showModal("Montenegro", true);
    this.modalLotesinClouster.showCompleteModal("Montenegro");
    this.colorizeClousterCircle(this.sixClousterThree);
    this.moveCameraTo(
      { x: 23.949, y: 19.675, z: -331.227 },
      { x: -1.037, y: -0.063, z: -0.107 }
    );
    this.control.target.set(26.98, -21.4, -355.52);
    this.camera.near = 0.1;
    this.changeMaxPandControl();
    this.control.enablePan = true;
    this.control.enableRotate = true;
    this.topCamera = false;
    this.ChnageColorLabelClouster(this.sixLabelClousterThree);
  }
  _moveToClousterOneZoneSeven() {
    this.control.enabled = true;
    this.control.maxDistance = 30;
    this.gltf.hoverClousters("", this);
    this.zoneModalInfo.showModal("Lucerna", true);
    this.modalLotesinClouster.showCompleteModal("Lucerna");
    this.colorizeClousterCircle(this.sevenClousterOne);
    this.moveCameraTo(
      { x: 47.854, y: 8.684, z: -186.655 },
      { x: -1.02, y: 0.113, z: 0.181 }
    );
    this.control.target.set(47.01, 2.32, -190.56);
    this.camera.near = 0.1;
    this.changeMaxPandControl();
    this.control.enablePan = true;
    this.control.enableRotate = true;
    this.topCamera = false;
    this.ChnageColorLabelClouster(this.sevenLabelClousterOne);
  }
  _moveToClousterTwoZoneSeven() {
    this.control.enabled = true;
    this.control.maxDistance = 30;
    this.gltf.hoverClousters("", this);
    this.zoneModalInfo.showModal("La cantera", true);
    this.modalLotesinClouster.showCompleteModal("cantera");
    this.colorizeClousterCircle(this.sevenClousterTwo);
    this.moveCameraTo(
      { x: 77.076, y: 6.936, z: -167.675 },
      { x: -1.043, y: 0.09, z: 0.153 }
    );
    this.control.target.set(76.59, 2.23, -170.41);
    this.camera.near = 0.1;
    this.changeMaxPandControl();
    this.control.enablePan = true;
    this.control.enableRotate = true;
    this.topCamera = false;
    this.ChnageColorLabelClouster(this.SevenLabelClousterTwo);
  }
  _moveToClousterThreeZoneSeven() {
    this.control.enabled = true;
    this.control.maxDistance = 30;
    this.gltf.hoverClousters("", this);
    this.zoneModalInfo.showModal("Terra Verde", true);
    this.modalLotesinClouster.showCompleteModal("TERRA");
    this.colorizeClousterCircle(this.sevenClousterThree);
    this.moveCameraTo(
      { x: 129.942, y: 10.698, z: -247.252 },
      { x: -1.301, y: 0.061, z: 0.217 }
    );
    this.control.target.set(129.49, 3.58, -249.22);
    this.camera.near = 0.01;
    this.changeMaxPandControl();
    this.control.enablePan = true;
    this.control.enableRotate = true;
    this.topCamera = false;
    this.ChnageColorLabelClouster(this.sevenLabelClousterThree);
  }
  _moveToClousterOneZoneEight() {
    this.control.enabled = true;
    this.control.maxDistance = 30;
    this.gltf.hoverClousters("", this);
    this.zoneModalInfo.showModal("Verona", true);
    this.modalLotesinClouster.showCompleteModal("Verona");
    this.colorizeClousterCircle(this.eightClousterTwo);

    this.moveCameraTo(
      { x: -73.477, y: 14.618, z: 82.176 },
      { x: -1.158, y: 0.039, z: 0.089 }
    );
    this.control.target.set(-74.12, 0.32, 75.63);
    this.camera.near = 0.1;
    this.changeMaxPandControl();
    this.control.enablePan = true;
    this.control.enableRotate = true;
    this.topCamera = false;
    this.ChnageColorLabelClouster(this.eightLabelClousterTwo);
  }
  _moveToClousterTwoZoneEight() {
    this.control.enabled = true;
    this.control.maxDistance = 30;
    this.gltf.hoverClousters("", this);
    this.zoneModalInfo.showModal("Sorrento", true);
    this.modalLotesinClouster.showCompleteModal("Sorrento");
    this.colorizeClousterCircle(this.eightClousterThree);
    this.moveCameraTo(
      { x: -61.818, y: 13.833, z: 114.15 },
      { x: -1.199, y: 0.247, z: 0.56 }
    );
    this.control.target.set(-65.6, -0.17, 108.7);

    this.camera.near = 0.1;
    this.changeMaxPandControl();
    this.control.enablePan = true;
    this.control.enableRotate = true;
    this.topCamera = false;
    this.ChnageColorLabelClouster(this.eightLabelClousterThree);
  }

  _moveToClousterThreeZoneEight() {
    this.control.enabled = true;
    this.control.maxDistance = 30;
    this.gltf.hoverClousters("", this);
    this.zoneModalInfo.showModal("trento", true);
    this.modalLotesinClouster.showCompleteModal("trento");
    this.colorizeClousterCircle(this.eightClousterOne);

    this.moveCameraTo(
      { x: -55.039, y: 13.852, z: 132.891 },
      { x: -1.115, y: 0.093, z: 0.188 }
    );
    this.control.target.set(-56.72, -2.31, 124.97);
    this.camera.near = 0.1;
    this.changeMaxPandControl(16);
    this.control.enablePan = true;
    this.control.enableRotate = true;
    this.topCamera = false;
    this.ChnageColorLabelClouster(this.eightLabelClousterOne);
  }
  _moveToClousterFourZoneEight() {
    this.control.enabled = true;
    this.control.maxDistance = 30;
    this.gltf.hoverClousters("", this);
    this.zoneModalInfo.showModal("Ferrara", true);
    this.modalLotesinClouster.showCompleteModal("Ferrara");
    this.colorizeClousterCircle(this.eightClousterFour);

    this.moveCameraTo(
      { x: -48.766, y: 17.36, z: 144.712 },
      { x: -1.375, y: 0.032, z: 0.157 }
    );
    this.control.target.set(-49.43,-3.31,140.61);
    this.camera.near = 0.1;
    this.changeMaxPandControl(16);
    this.control.enablePan = true;
    this.control.enableRotate = true;
    this.topCamera = false;
    this.ChnageColorLabelClouster(this.eightLabelClousterFour);
  }
  _moveToClousterFiveZoneEight() {
    this.control.enabled = true;
    this.control.maxDistance = 30;
    this.gltf.hoverClousters("", this);
    this.zoneModalInfo.showModal("Siena", true);
    this.modalLotesinClouster.showCompleteModal("Siena");
    this.colorizeClousterCircle(this.eightClousterFive);

    this.moveCameraTo(
      { x: -99.831, y: 20.103, z: 94.798 },
      { x: -1.148, y: 0.061, z: 0.135 }
    );
    this.control.target.set(-101.21,-0.41,85.57);
    this.camera.near = 0.1;
    this.changeMaxPandControl(20);
    this.control.enablePan = true;
    this.control.enableRotate = true;
    this.topCamera = false;
    this.ChnageColorLabelClouster(this.eightLabelClousterFive);
  }

  moveCameraTo(position, rotation, time = 1, callBack = () => {}) {
    let animations = gsap.timeline();
    animations
      .to(this.camera.position, {
        duration: time,
        x: position.x,
        y: position.y,
        z: position.z,
        onComplete: () => {
          this.menuClickEnable = true;
          callBack();
        },
      })
      .to(
        this.camera.rotation,
        {
          duration: time,
          x: rotation.x,
          y: rotation.y,
          z: rotation.z,
        },
        `-=${time}`
      );
  }
}
